var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"ButtonNext",attrs:{"type":"success","disabled":_vm.disabled},on:{"click":_vm.next}},[_vm._v("Siguiente")])}
var staticRenderFns = []

export { render, staticRenderFns }